// extracted by mini-css-extract-plugin
export default {"label":"SeasonCreate_label__Ruo5a","container":"SeasonCreate_container__NO3AW"};